'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Flame } from 'lucide-react';
const HERO_IMAGE_SRC = '/static/home/sizzle-nz-hero.png';
const AUDIENCES = ['Founders', 'Brands', 'Retailers', 'Buyers', 'Distributors', 'Importers', 'Brokers', 'Consultants', 'Agencies', 'Creators', 'Suppliers', 'Organisers'];
export function HeroSectionSizzleNZ() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-x-0 top-0 h-1 bg-primary-500" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><h1 className="max-w-3xl text-4xl font-black leading-[1.02] tracking-normal text-gray-950 sm:text-5xl lg:text-5xl xl:text-5xl">New Zealand's Food, Beverage and Consumer Goods Platform</h1></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="font-bold text-lg text-gray-600 sm:text-3xl"><span className="font-black text-primary-600">Get Inspired and Make Smarter Moves</span>{" "}to Create More Demand for Your Products and Convert that Demand into Purchases.</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mt-4 grid max-w-xl gap-5 sm:mt-6 sm:gap-8 xl:mt-8">{t2}<p className="font-bold text-lg text-gray-600 sm:text-3xl"><span className="font-black text-primary-600">Connect with the Right Expert Help</span>{" "}to execute Your Next Moves, and to go from Idea to Launch Faster and More Successfully.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-white"><Flame className="h-4 w-4" aria-hidden="true" /></span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="relative z-10 flex flex-col lg:col-span-6 xl:col-span-6 xl:justify-center xl:gap-10">{t1}{t3}<Link href="/early-preview" className="mt-8 mb-4 inline-flex items-center gap-2 text-sm font-semibold text-gray-700 transition-colors hover:text-primary-600 sm:mb-7">{t4}<span>Early Preview - very under construction -{" "}<span className="text-primary-600 underline">Learn more</span></span></Link></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="relative h-[270px] sm:h-[470px] lg:h-[460px] xl:h-[500px]"><img src={HERO_IMAGE_SRC} alt="Illustrated New Zealand consumer brands building momentum through Sizzle" className="absolute inset-0 h-full w-full object-contain" /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="mb-1 text-xs font-black uppercase tracking-wider text-primary-600 sm:text-sm">Our Mission</p>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-primary-600">Want</span>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="grid items-center gap-4 sm:gap-8 lg:grid-cols-12 lg:gap-6 xl:items-stretch xl:gap-10">{t5}<div className="relative z-10 flex flex-col lg:col-span-6 xl:col-span-6">{t6}<div className="mx-auto -mt-2 max-w-xl rounded-2xl border border-primary-100 bg-primary-50/60 px-5 py-4 text-center shadow-sm sm:px-6 sm:py-5">{t7}<p className="font-bold text-lg leading-snug text-gray-800 sm:text-2xl">More people {t8} and{" "}<span className="text-primary-600">Purchase</span> your Products. More NZ 🇳🇿 Product is Wanted by and Purchased by the World 🌎</p></div></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="mb-2 text-base text-gray-600 sm:mb-3 sm:text-xl">Sizzle is for:</p>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <section className="relative isolate overflow-hidden border-b border-orange-100 bg-[#fffaf4]">{t0}<div className="relative mx-auto max-w-[1440px] px-5 py-5 sm:px-8 sm:py-6 lg:px-12 lg:py-6">{t9}<div className="mt-4 border-t border-gray-900/15 pt-4 sm:mt-8 sm:pt-5 lg:mt-6">{t10}<div className="flex flex-wrap gap-x-4 gap-y-1 sm:gap-x-5 sm:gap-y-2">{AUDIENCES.map(_temp)}</div></div></div></section>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}
function _temp(audience) {
  return <span key={audience} className="text-sm font-semibold text-gray-800 sm:text-base">{audience}</span>;
}